<template>
  <div class="cl-inner">
    <div v-show="this.$route.path == '/paySetting'">
      <div style="margin-top: 20px">
        <span style="font-weight: 700">支付方式列表</span>
        <router-link :to="{ path: '/addPaySetting' }">
          <a-button style="margin-left: 10px" type="primary">
            <a-icon type="plus" />
            新增支付设置
          </a-button></router-link
        >

        <a-table
          style="margin-top: 30px"
          bordered
          :columns="columns"
          :dataSource="payList"
          :loading="loading"
          :pagination="false"
          :locale="locale"
          rowKey="id"
        >
          <span slot="action" slot-scope="text, record">
            <template>
              <a
                @click="
                  $router.push({
                    name: 'addPaySetting',
                    query: {
                      record: JSON.stringify(record),
                    },
                  })
                "
                >修改</a
              >
            </template>
          </span>

          <span slot="enabled" slot-scope="text, record">
            <template>
              <a-switch
                :defaultChecked="record.enabled == 1"
                @change="changeEnabled(record)"
              />
            </template>
          </span>
          <span slot="gmtModified" slot-scope="text, record">
            <template>
              {{ moment(record.gmtModified).format('YYYY-MM-DD HH:mm') }}
            </template>
          </span>
        </a-table>
      </div>
      <p class="cut-off"></p>
      <div class="remark">
        <img src="/icon/warning.png" style="width: 20px; margin-bottom: 3px" />
        注意，如下情况将采用教体局站点端的支付设置：
      </div>
      <ul>
        <li>1.学校未设置支付方式；</li>
        <li>2.学校有设置支付方式，所有设置支付方式未启用；</li>
        <li>
          3.学校有设置支付方式，设置支付方式有启用，启用支付方式不符合适用范围，例如课程分类不适用；
        </li>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import finOrder from '../../api/finOrder'
import moment from 'moment'
const columns = [
  {
    title: '支付编号',
    dataIndex: 'id',
    align: 'center',
  },
  {
    title: '支付方式名称',
    dataIndex: 'configName',
    align: 'center',
  },
  {
    title: '收款对接渠道',
    dataIndex: 'payChannel',
    align: 'center',
  },
  {
    title: '收款支付方式',
    dataIndex: 'payMethod',
    align: 'center',
  },
  {
    title: '启用',
    dataIndex: 'enabled',
    align: 'center',
    scopedSlots: {
      customRender: 'enabled',
    },
  },
  {
    title: '设置',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: {
      customRender: 'action',
    },
  },
  {
    title: '最后修改时间',
    dataIndex: 'gmtModified',
    align: 'center',
    scopedSlots: {
      customRender: 'gmtModified',
    },
  },
]
export default {
  data() {
    return {
      moment,
      columns,
      userInfo: {},
      payList: [],
      loading: false,
      locale: {
        emptyText: () => (
          <a-empty>
            <img src="/empty.png" style="width:120px" />
            <div slot="description"> 暂无支付方式设置 </div>
          </a-empty>
        ),
      }, //空数据默认显示
    }
  },
  created() {
    console.log('route')
    this.$store.dispatch('getUserInfo').then((res) => {
      console.log('res', res)
      this.userInfo = res
      this.getPayConfigListV2({
        unitId: this.userInfo.bureauId,
        userId: this.userInfo.id,
      })
    })
  },
  methods: {
    //启用
    changeEnabled(record) {
      console.log('record', record)
      finOrder
        .payV2Enabled({ id: record.id, enabled: record.enabled == 1 ? 0 : 1 })
        .then((res) => {
          // console.log('success')
          // console.log('changeEnabledres', res)
          this.$message.success('操作成功')
          this.getPayConfigListV2({
            unitId: this.userInfo.bureauId,
            userId: this.userInfo.id,
          })
        })
        .catch((e) => {
          // console.log('error')
          this.$message.error('操作失败')
        })
    },
    getPayConfigListV2(params) {
      console.log(params,123)
      finOrder.getPayConfigListV2(params).then((res) => {
        // console.log('res', res)
        this.payList = res.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.cut-off {
  height: 2px;
  background: #f3f4fa;
  margin-top: 50px !important;
}
.remark {
  margin-top: 10px;
}
ul {
  li {
    margin-top: 5px !important;
    margin-left: 20px !important;
  }
}
::v-deep .ant-table-thead > tr > th {
  font-weight: 700 !important;
  background-color: #f0f0f0;
}
</style>
